import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

// Einheitlicher Seiten-Header für ALLE /app-Tabs: kleines Icon (in dezenter Accent-Kachel) + Titel,
// optional Untertitel und ein rechter Slot für Seiten-Aktionen. Überall gleiche Größe/Gewicht/Abstände,
// damit die Kopfzeilen nicht mehr von Seite zu Seite springen. Icon = das jeweilige Nav-Icon der Seite.
export function PageHeader({ icon: Icon, title, subtitle, right, className = '' }: {
  icon: LucideIcon;
  title: ReactNode;
  subtitle?: ReactNode;
  right?: ReactNode;
  className?: string;
}) {
  return (
    <div className={`flex items-center justify-between gap-3 mb-4 ${className}`}>
      <div className="flex items-center gap-2 min-w-0">
        <Icon size={20} className="shrink-0 text-accent" />
        <div className="min-w-0">
          <h1 className="text-xl font-bold text-text-main leading-tight truncate">{title}</h1>
          {subtitle && <p className="text-xs text-text-muted truncate">{subtitle}</p>}
        </div>
      </div>
      {right && <div className="shrink-0 flex items-center gap-2">{right}</div>}
    </div>
  );
}
